// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__lqfWr","col":"styles_col__OrL31","fulfillmentStatus":"styles_fulfillmentStatus__l-n2H","emailCol":"styles_emailCol__1DLoV"};